export enum SessionFieldEnum {
  AccessToken = "a",
  RefreshToken = "r"
}

export enum GoogleDriveEnum {
  GoogleDriveState = "gd",
}

